import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Completed: FunctionComponent<IconProps> = ({
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 43 43"
      fill="none"
    >
      <path
        d="M7.43693 9.48127C12.7601 3.25312 21.5458 1.26811 29.0296 4.60269C29.7863 4.93986 30.6731 4.59976 31.0103 3.84305C31.3474 3.08634 31.0073 2.19957 30.2506 1.8624C21.5533 -2.01292 11.3428 0.293991 5.15641 7.53211C-1.03002 14.7702 -1.71877 25.2153 3.46367 33.2031C8.64612 41.1909 18.4652 44.8185 27.5961 42.1188C36.7271 39.4191 42.9947 31.0351 43.0001 21.5134V19.6725C43.0001 18.8441 42.3285 18.1725 41.5001 18.1725C40.6717 18.1725 40.0001 18.8441 40.0001 19.6725V21.5117C39.9954 29.7048 34.6024 36.9189 26.7455 39.2419C18.8887 41.5649 10.4397 38.4435 5.98039 31.5703C1.52108 24.6971 2.11372 15.7094 7.43693 9.48127Z"
        fill="#327EA5"
      />
      <path
        d="M42.5613 6.57269C43.1468 5.98661 43.1463 5.03686 42.5603 4.45137C41.9742 3.86588 41.0244 3.86635 40.4389 4.45243L21.4996 23.4107L16.5608 18.4719C15.975 17.8861 15.0253 17.8861 14.4395 18.4719C13.8537 19.0577 13.8537 20.0074 14.4395 20.5932L20.4395 26.5932C20.7209 26.8746 21.1026 27.0327 21.5005 27.0326C21.8985 27.0325 22.2801 26.8742 22.5613 26.5927L42.5613 6.57269Z"
        fill="#327EA5"
      />
    </svg>
  </IconWrapper>
);

Completed.displayName = 'Completed';
